import { useAuthStore } from '../stores/auth'

export type ModuleKey =
  | 'multipoint'
  | 'dailyTariffs'
  | 'discounts'
  | 'bookings'
  | 'ocr'
  | 'notifications'
  | 'service'
  | 'payroll'
  | 'managerShifts'

/**
 * Whether a tenant feature module is enabled for the current user.
 * Mirrors the API contract: a module is enabled unless explicitly `false`,
 * so missing data (e.g. before /me resolves) defaults to enabled — never
 * hides existing functionality.
 */
export function useModule(key: ModuleKey): boolean {
  const modules = useAuthStore((s) => s.user?.modules)
  return modules?.[key] !== false
}
